var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-footer d-flex justify-center"},_vm._l((_vm.icons),function(icon,index){return _c('a',{key:index,staticClass:"social-footer-link mx-2",attrs:{"href":icon.link,"target":"_blank"}},[_c('v-btn',{attrs:{"dark":"","icon":"","large":""}},[_c('v-icon',{attrs:{"size":"24px"}},[_vm._v(" "+_vm._s(icon.icon)+" ")])],1)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }